import { useEffect, useState } from 'react';
import { listCasesAndLeads } from 'services/CaseServices';

export function useCaseAndLeadsList(case_id, exclude_pi_case) {
  const [List, setList] = useState([]);

  useEffect(() => {
    if (!case_id) {
      setList([]);
      return;
    }

    const loadCaseAndLeadsList = () => {
      listCasesAndLeads(false, case_id, exclude_pi_case)
        .then((response) => setList(response?.data))
        .catch((error) => console.log(error));
    };

    loadCaseAndLeadsList();
  }, [case_id, exclude_pi_case]);

  return { caseAndLeadsList: List };
}
